import { useEffect, useRef } from "react";
import { components } from 'react-select';
const { MenuList } = components;

const ReportingManagerMenuList = (props) => {
    const listRef = useRef(null);
    const scrollTopRef = useRef(0);
    const prevOptionsLength = useRef(props.options?.length || 0);

    const isLoadingMore = props.selectProps.isLoadingMore;      
    const onLoadMore = props.selectProps.onLoadMore;            

    useEffect(() => {
        const currentLength = props.options?.length || 0;
        const prevLength = prevOptionsLength.current;

        if (listRef.current && currentLength > prevLength) {
            listRef.current.scrollTop = scrollTopRef.current;
        }

        prevOptionsLength.current = currentLength;
    }, [props.options?.length]);

    const originalOnScroll = props?.innerProps?.onScroll;

    const checkAndLoadNextPage = (target) => {
        if (!target) return;
        const reachedBottom = (target.scrollTop + target.clientHeight) >= (target.scrollHeight - 4);
        if (reachedBottom) {
            onLoadMore();                                  
        }
    };

    const handleScroll = (event) => {
        scrollTopRef.current = event.target.scrollTop;
        if (typeof originalOnScroll === "function") {
            originalOnScroll(event);
        }
        checkAndLoadNextPage(event?.target);
    };

    const handleWheel = (event) => {
        checkAndLoadNextPage(event?.currentTarget);
    };

    const handleTouchMove = (event) => {
        checkAndLoadNextPage(event?.currentTarget);
    };

    return (
        <MenuList
            {...props}
            innerProps={{
                ...props.innerProps,
                ref: listRef,
                onScroll: handleScroll,
                onWheel: handleWheel,
                onTouchMove: handleTouchMove,
            }}
        >
            {props.children}
            {isLoadingMore && (
                <div style={{ textAlign: 'center', padding: '8px', color: '#999', fontSize: '13px' }}>
                    Loading...
                </div>
            )}
        </MenuList>
    );
}; 

export default ReportingManagerMenuList;